// Shared view-grouping state helpers.
//
// Originally extracted in TAD-5151 from the legacy task list (`tasks-combined-table-page.js`)
// so the active project list (`project-table-page.jsx`) could keep using these helpers
// after the legacy task list was decoupled. The legacy task list has since been deleted
// in TAD-5777; the active project list remains the primary consumer.

/**
 * Convert an underscore-delimited "group_subgroup" identifier to camelCase.
 *
 * Example: getAccessor("viewAll_active") => "viewAllActive"
 *
 * @param {string} type An identifier of the form `<group>_<subgroup>` (e.g. "viewAll_active",
 *   "show_completed", "task_priority"). The first segment is kept verbatim; the second
 *   segment has its first character upper-cased and is concatenated to the first.
 * @returns {string} The camelCased accessor key.
 */
export const getAccessor = (type) => {
    const identifier = type.split("_")[0];
    const subgroup = type.split("_")[1];
    let accessor = subgroup.split('');
    accessor[0] = accessor[0].toUpperCase();
    accessor = accessor.join("");

    return identifier + accessor;
};

/**
 * Immutably update a single accessor on a view-grouping state object.
 *
 * - actionType === "toggle" flips the boolean at `accessor`.
 * - any other actionType assigns `payload` to `accessor` (typically a "set" action).
 *
 * @param {Object} prev The previous state object (e.g. `category`, `priority`, `permission`).
 * @param {string} accessor The camelCased key returned by `getAccessor`.
 * @param {*} payload The value to assign when actionType is not "toggle".
 * @param {string} actionType "toggle" or any other string (typically "set").
 * @returns {Object} A new state object with the targeted accessor updated.
 */
export const handleViewGrouping = (prev, accessor, payload, actionType) => {
    let copy = { ...prev };

    if (actionType === "toggle") copy[accessor] = !prev[accessor];
    else copy[accessor] = payload;

    return copy;
};
